import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveMeetingMutationVariables = Types.Exact<{
  meeting: Types.SaveMeetingInput;
}>;


export type SaveMeetingMutation = { __typename?: 'Mutation', saveMeeting: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'FieldError', path: Array<string>, data:
        | { __typename?: 'GenericError', key: Types.ValueErrorType }
        | { __typename?: 'LimitedValueError', key: Types.ValueErrorType, limitValue: number }
        | { __typename?: 'PositiveRangeDatetimeError', key: Types.ValueErrorType }
       }> | null } };

export type UpdateMeetingQueryVariables = Types.Exact<{
  meetingId: Types.Scalars['Int']['input'];
}>;


export type UpdateMeetingQuery = { __typename?: 'Query', meetings?: { __typename?: 'MeetingList', items: Array<{ __typename?: 'Meeting', id: number, startTime: any, length?: number | null, summary: string, pinCode?: string | null, description?: string | null, allowUnmute: boolean } | null> } | null, invitations?: { __typename?: 'InvitationList', items: Array<{ __typename?: 'Invitation', id: number, pinCodeRequired: boolean, callout: boolean, muted: boolean, email?: string | null, phoneNumber?: string | null, name?: string | null, type: Types.InvitationType, isAutoGenerated: boolean } | null> } | null };


export const SaveMeetingDocument = gql`
    mutation SaveMeeting($meeting: SaveMeetingInput!) {
  saveMeeting(meeting: $meeting) {
    id
    errors {
      path
      data {
        ... on GenericError {
          key
        }
        ... on LimitedValueError {
          key
          limitValue
        }
        ... on PositiveRangeDatetimeError {
          key
        }
      }
    }
  }
}
    `;
export type SaveMeetingMutationFn = Apollo.MutationFunction<SaveMeetingMutation, SaveMeetingMutationVariables>;

/**
 * __useSaveMeetingMutation__
 *
 * To run a mutation, you first call `useSaveMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMeetingMutation, { data, loading, error }] = useSaveMeetingMutation({
 *   variables: {
 *      meeting: // value for 'meeting'
 *   },
 * });
 */
export function useSaveMeetingMutation(baseOptions?: Apollo.MutationHookOptions<SaveMeetingMutation, SaveMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMeetingMutation, SaveMeetingMutationVariables>(SaveMeetingDocument, options);
      }
export type SaveMeetingMutationHookResult = ReturnType<typeof useSaveMeetingMutation>;
export type SaveMeetingMutationResult = Apollo.MutationResult<SaveMeetingMutation>;
export type SaveMeetingMutationOptions = Apollo.BaseMutationOptions<SaveMeetingMutation, SaveMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    query UpdateMeeting($meetingId: Int!) {
  meetings(id: $meetingId) {
    items {
      id
      startTime
      length
      summary
      pinCode
      description
      allowUnmute
    }
  }
  invitations(meetingId: $meetingId) {
    items {
      id
      pinCodeRequired
      callout
      muted
      email
      phoneNumber
      name
      type
      isAutoGenerated
    }
  }
}
    `;

/**
 * __useUpdateMeetingQuery__
 *
 * To run a query within a React component, call `useUpdateMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateMeetingQuery({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useUpdateMeetingQuery(baseOptions: Apollo.QueryHookOptions<UpdateMeetingQuery, UpdateMeetingQueryVariables> & ({ variables: UpdateMeetingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateMeetingQuery, UpdateMeetingQueryVariables>(UpdateMeetingDocument, options);
      }
export function useUpdateMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateMeetingQuery, UpdateMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateMeetingQuery, UpdateMeetingQueryVariables>(UpdateMeetingDocument, options);
        }
// @ts-ignore
export function useUpdateMeetingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateMeetingQuery, UpdateMeetingQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateMeetingQuery, UpdateMeetingQueryVariables>;
export function useUpdateMeetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateMeetingQuery, UpdateMeetingQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateMeetingQuery | undefined, UpdateMeetingQueryVariables>;
export function useUpdateMeetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateMeetingQuery, UpdateMeetingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateMeetingQuery, UpdateMeetingQueryVariables>(UpdateMeetingDocument, options);
        }
export type UpdateMeetingQueryHookResult = ReturnType<typeof useUpdateMeetingQuery>;
export type UpdateMeetingLazyQueryHookResult = ReturnType<typeof useUpdateMeetingLazyQuery>;
export type UpdateMeetingSuspenseQueryHookResult = ReturnType<typeof useUpdateMeetingSuspenseQuery>;
export type UpdateMeetingQueryResult = Apollo.QueryResult<UpdateMeetingQuery, UpdateMeetingQueryVariables>;